module.exports = __webpack_public_path__ + "img/1.465a4a73.jpg";